'use-client';
import * as React from 'react';
import type { IFocusPropsImperativeActions } from '@wix/editor-elements-corvid-utils';
import SiteButton from '../../SiteButton';
import type { SkinButtonProps } from '../SkinButton.types';
import type {
  ISiteButtonImperativeActions,
  ISiteButtonProps,
} from '../../../SiteButton.types';
import ButtonForkedSkin from './ButtonForkedSkin';
import skinsStyle from './styles/ButtonForkedRight.scss';

const ButtonForkedRightSkin = React.forwardRef<
  ISiteButtonImperativeActions,
  SkinButtonProps
>((props, ref) => (
  <ButtonForkedSkin
    {...props}
    skinsStyle={skinsStyle}
    ref={ref}
  ></ButtonForkedSkin>
));

const ButtonForkedRight: React.ForwardRefRenderFunction<
  IFocusPropsImperativeActions,
  Omit<ISiteButtonProps, 'skin'>
> = (props, ref) => (
  <SiteButton {...props} skin={ButtonForkedRightSkin} ref={ref} />
);

export default React.forwardRef(ButtonForkedRight);
